import { Box, Link as MuiLink } from "@mui/material";
import ReactMarkdown, { type Components } from "react-markdown";

const markdownComponents: Components = {
  a({ href, children }) {
    const external = href?.startsWith("http");
    return (
      <MuiLink
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noreferrer" : undefined}
      >
        {children}
      </MuiLink>
    );
  },
};

interface MarkdownDocumentProps {
  children: string;
}

export default function MarkdownDocument({ children }: MarkdownDocumentProps) {
  return (
    <Box
      sx={(theme) => ({
        "& h1": {
          ...theme.typography.h2,
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(1.5),
        },
        "& > h1 + p": {
          ...theme.typography.h4,
          marginTop: 0,
          marginBottom: theme.spacing(1),
        },
        "& > h1 + p + p": {
          ...theme.typography.body2,
          color: theme.palette.text.secondary,
          marginTop: 0,
          marginBottom: theme.spacing(3),
        },
        "& h2": {
          ...theme.typography.h3,
          marginTop: theme.spacing(3.5),
          marginBottom: theme.spacing(1.5),
        },
        "& h3": {
          ...theme.typography.h4,
          marginTop: theme.spacing(2.5),
          marginBottom: theme.spacing(1.5),
        },
        "& p": {
          ...theme.typography.body1,
          marginTop: 0,
          marginBottom: theme.spacing(1.5),
        },
        "& ul": {
          marginTop: 0,
          marginBottom: theme.spacing(1.5),
          paddingLeft: theme.spacing(3),
        },
        "& li": {
          ...theme.typography.body1,
          marginBottom: theme.spacing(0.75),
        },
      })}
    >
      <ReactMarkdown components={markdownComponents}>{children}</ReactMarkdown>
    </Box>
  );
}
